/* Patriot Craftsmen – custom order request form */
(function () {
  'use strict';

  var MAX_FILES = 6;
  var MAX_TOTAL_BYTES = 9.5 * 1024 * 1024; // FormSubmit allows 10MB total
  var MAX_DIMENSION = 2000;
  var canSetFiles = (function () {
    try {
      return typeof DataTransfer !== 'undefined' && !!new DataTransfer().items;
    } catch (e) {
      return false;
    }
  })();

  function formatBytes(bytes) {
    if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function compressImage(file) {
    return new Promise(function (resolve) {
      if (!/^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type) || file.size < 900 * 1024) {
        resolve(file);
        return;
      }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var scale = Math.min(1, MAX_DIMENSION / Math.max(img.naturalWidth, img.naturalHeight));
        var canvas = document.createElement('canvas');
        canvas.width = Math.round(img.naturalWidth * scale);
        canvas.height = Math.round(img.naturalHeight * scale);
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(url);
        canvas.toBlob(
          function (blob) {
            if (!blob || blob.size >= file.size) {
              resolve(file);
              return;
            }
            var name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
            try {
              resolve(new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }));
            } catch (e) {
              resolve(file);
            }
          },
          'image/jpeg',
          0.82
        );
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        resolve(file);
      };
      img.src = url;
    });
  }

  function init(root) {
    if (root.dataset.pcInit) return;
    root.dataset.pcInit = '1';
    var form = root.querySelector('[data-pc-form]');
    if (!form) return;
    var params = new URLSearchParams(window.location.search);
    var successBox = root.querySelector('[data-pc-success]');
    var errorBox = root.querySelector('[data-pc-error]');
    var submitBtn = root.querySelector('[data-pc-submit]');

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = !message;
    }

    // Success state after FormSubmit redirects back with ?sent=1
    if (params.get('sent') === '1' && successBox && window.location.hash === '#' + root.id) {
      successBox.hidden = false;
      form.hidden = true;
      requestAnimationFrame(function () {
        successBox.focus({ preventScroll: true });
        root.scrollIntoView({ block: 'start' });
      });
    }

    // Needed-by date can't be in the past
    var dateInput = root.querySelector('[data-pc-date]');
    if (dateInput) {
      var d = new Date();
      dateInput.min = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    }

    // General request page: prefill product from ?product=<handle> or ?item=<text>
    var whatInput = root.querySelector('[data-pc-what]');
    if (whatInput) {
      var handle = params.get('product');
      var item = params.get('item');
      if (handle && whatInput.list) {
        var match = whatInput.list.querySelector('option[data-handle="' + CSS.escape(handle) + '"]');
        if (match) whatInput.value = match.value;
      } else if (item) {
        whatInput.value = item;
      }
    }

    // Product page: keep selected variant in sync with the theme's variant picker
    var variantsJson = root.querySelector('[data-pc-variants]');
    if (variantsJson) {
      var variants = {};
      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch (e) {}
      var label = root.querySelector('[data-pc-variant-label]');
      var variantField = root.querySelector('[data-pc-variant-field]');
      var priceField = root.querySelector('[data-pc-price-field]');
      var syncVariant = function () {
        var id = new URLSearchParams(window.location.search).get('variant');
        var v = id && variants[id];
        if (!v) return;
        var isDefault = v.title === 'Default Title';
        if (label) label.textContent = (isDefault ? '' : v.title + ' · ') + v.price;
        if (variantField) variantField.value = v.title;
        if (priceField) priceField.value = v.plain;
      };
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-picker')) {
          setTimeout(syncVariant, 350);
          setTimeout(syncVariant, 1000);
        }
      });
      syncVariant();
    }

    // Photo uploads (FormSubmit only)
    var picker = root.querySelector('[data-pc-file-picker]');
    var slots = root.querySelector('[data-pc-file-slots]');
    var list = root.querySelector('[data-pc-file-list]');
    var files = [];

    if (picker && !canSetFiles) {
      // Older browsers: submit the picker directly, without resizing.
      picker.name = 'Photos';
    }

    function renderList() {
      if (!list) return;
      list.innerHTML = '';
      files.forEach(function (file, index) {
        var li = document.createElement('li');
        li.className = 'pc-file';
        if (/^image\//.test(file.type)) {
          var thumb = document.createElement('img');
          thumb.alt = '';
          thumb.src = URL.createObjectURL(file);
          thumb.onload = function () {
            URL.revokeObjectURL(thumb.src);
          };
          li.appendChild(thumb);
        } else {
          var badge = document.createElement('span');
          badge.className = 'pc-file__badge';
          badge.textContent = (file.name.split('.').pop() || 'file').toUpperCase();
          li.appendChild(badge);
        }
        var meta = document.createElement('span');
        meta.className = 'pc-file__meta';
        meta.textContent = file.name + ' · ' + formatBytes(file.size);
        li.appendChild(meta);
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'pc-file__remove';
        remove.setAttribute('aria-label', 'Remove ' + file.name);
        remove.innerHTML = '&times;';
        remove.addEventListener('click', function () {
          files.splice(index, 1);
          renderList();
        });
        li.appendChild(remove);
        list.appendChild(li);
      });
    }

    if (picker && canSetFiles) {
      picker.addEventListener('change', function () {
        var incoming = Array.prototype.slice.call(picker.files || []);
        picker.value = '';
        if (!incoming.length) return;
        showError('');
        var room = MAX_FILES - files.length;
        if (incoming.length > room) {
          showError('You can attach up to ' + MAX_FILES + ' files. Text extra photos to us after sending.');
          incoming = incoming.slice(0, Math.max(0, room));
        }
        if (list) list.classList.add('is-loading');
        Promise.all(incoming.map(compressImage)).then(function (processed) {
          files = files.concat(processed);
          if (list) list.classList.remove('is-loading');
          renderList();
        });
      });
    }

    form.addEventListener('submit', function (event) {
      showError('');
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
        event.preventDefault();
        return;
      }
      var honey = form.querySelector('input[name="_honey"]');
      if (honey && honey.value) {
        event.preventDefault();
        return;
      }
      if (picker && canSetFiles && slots) {
        var total = files.reduce(function (sum, f) {
          return sum + f.size;
        }, 0);
        if (total > MAX_TOTAL_BYTES) {
          event.preventDefault();
          showError(
            'Your photos add up to ' + formatBytes(total) + '. Please remove one or two (10 MB max) and text the rest to us.'
          );
          return;
        }
        slots.innerHTML = '';
        files.forEach(function (file, i) {
          var dt = new DataTransfer();
          dt.items.add(file);
          var input = document.createElement('input');
          input.type = 'file';
          input.name = 'Photo ' + (i + 1);
          input.files = dt.files;
          slots.appendChild(input);
        });
      }
      var subject = form.querySelector('[data-pc-subject]');
      var nameInput = form.querySelector('input[autocomplete="name"]');
      if (subject && nameInput && nameInput.value && subject.value.indexOf(' from ') === -1) {
        subject.value = subject.value + ' from ' + nameInput.value.trim();
      }
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = files.length ? 'Uploading photos & sending…' : 'Sending…';
      }
    });

    // If the browser restores this page from cache (back button), re-enable the button.
    window.addEventListener('pageshow', function () {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.getAttribute('data-label') || submitBtn.textContent;
      }
    });
    if (submitBtn) submitBtn.setAttribute('data-label', submitBtn.textContent.trim());
  }

  function boot() {
    document.querySelectorAll('[data-pc-request]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
